import styles from './GoldScreenLayout.module.scss';
import bgStyles from './goldBackgrounds.module.scss';
import brand from '../../images/gold/brand.png';
import { pixelsToVH, pixelsToVW } from '../EntryPage/EntryPage';

const BG_CLASS = {
  entry: bgStyles.bgEntry,
  camera: bgStyles.bgCamera,
  final: bgStyles.bgFinal,
};

function GoldScreenLayout({ children, showLogo = true, onLogoClick, bg = 'final' }) {
  return (
    <div className={`${styles.screen} ${BG_CLASS[bg] || BG_CLASS.final}`.trim()}>
      {showLogo ? (
        <header
          className={styles.header}
          style={{
            padding: `${pixelsToVH(40)} ${pixelsToVW(48)} 0`,
          }}
        >
          <img
            src={brand}
            alt="World Gold Council"
            className={styles.logo}
            style={{
              height: pixelsToVH(84),
              width: 'auto',
              maxWidth: pixelsToVW(320),
            }}
            onClick={onLogoClick}
          />
        </header>
      ) : null}
      <div className={styles.body}>{children}</div>
    </div>
  );
}

export default GoldScreenLayout;
